<template>
  <div class="alphabet-grid">
    <NuxtLink
      v-for="char of 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'"
      :key="char"
      class="alphabet-character"
      :class="{ active: char === activeChar }"
      :to="{ query: { startsWith: char } }"
    >
      {{ char }}
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { useRouteQuery } from "@vueuse/router";

const activeChar = useRouteQuery("startsWith", "", {
  transform: String,
});
</script>

<style lang="scss" scoped>
.alphabet-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.alphabet-character {
  width: 2.75rem;
  height: 2.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid $dark-50;
  border-radius: 4px;
  font-size: 1.5rem;
  font-weight: 600;

  &.active {
    background-color: var(--primary);
    border-color: var(--primary);
    color: $light-100;
  }
}
</style>
